import { Img } from "@/components/image";
import { cn } from "@/lib/utils";
import type { MobileAppDataType } from "@/types/mobile-app-data.type";

export const DiscountMobileApp = ({
  mobileAppData,
  showAppButton,
  strapiUrl,
}: {
  mobileAppData: MobileAppDataType;
  showAppButton: boolean;
  strapiUrl: (path: string) => string;
}) => {
  return (
    <div
      className={cn(
        "col-start-1 row-start-1 flex items-center justify-center gap-2.5 transition-transform duration-300 ease-out",
        showAppButton ? "translate-y-0" : "translate-y-full",
      )}
    >
      <a
        href={mobileAppData?.androidLink}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Img
          alt={mobileAppData?.androidImage.name ?? ""}
          className="w-[112px] xl:w-[145px]"
          height={mobileAppData?.androidImage.height}
          src={strapiUrl(mobileAppData?.androidImage.url)}
          width={mobileAppData?.androidImage.width}
        />
      </a>
      <a
        href={mobileAppData?.iosLink}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Img
          alt={mobileAppData?.iosImage.name ?? ""}
          className="w-[112px] xl:w-[145px]"
          height={mobileAppData?.iosImage.height ?? 0}
          src={strapiUrl(mobileAppData?.iosImage.url)}
          width={mobileAppData?.iosImage.width ?? 0}
        />
      </a>
    </div>
  );
};
